import styles from "@/components/pages/beats/styles/setting-header.module.scss";
import Image from "next/image";
import settingsIcon from "@/assets/icons/history-item-menu-icon-red.svg";
import Checkbox from "@/components/common/checkbox";

type BpmSettingHeaderProps = {
  isManualTempo: boolean;
  setIsManualTempo: (value: boolean) => void;
};

const BpmSettingHeader = ({
  isManualTempo,
  setIsManualTempo,
}: BpmSettingHeaderProps) => {
  return (
    <div
      className={styles.settings_block_header}
      onClick={() => setIsManualTempo(!isManualTempo)}
    >
      <div className={styles.icon_title_wrapper}>
        <Image alt={""} src={settingsIcon} />
        <div className={styles.setting_header_text}>Set tempo manually</div>
      </div>
      <Checkbox isChecked={isManualTempo} onChange={() => {}} />
    </div>
  );
};

export default BpmSettingHeader;
